import assign from 'object-assign';
import namespace from './namespace';
import {googleAnalyticsLayer} from './data-layer-ga';
import {facebookPixelLayer} from './data-layer-fbq';

const dataLayer = namespace( 'dataLayer' );
const dataLayerProto = {};

dataLayer.create = ( obj ) => assign( {}, dataLayerProto, obj );

export const cart = dataLayer.create( {
    sendCrossSellItems( list = [], callback ) {
        googleAnalyticsLayer.crossSellItems( list, callback );
        return this;
    },

    sendItemsAdded( items = [], callback ) {
        googleAnalyticsLayer.itemsAdded( items, callback );
        facebookPixelLayer.itemsAdded( items );
        return this;
    },

    sendItemsRemoved( items = [], callback ) {
        googleAnalyticsLayer.itemsRemoved( items, callback );
        return this;
    }
} );

export const product = dataLayer.create( {
    sendProductView( sku, callback ) {
        googleAnalyticsLayer.productView( sku, callback );
        facebookPixelLayer.productView( sku );
        return this;
    }
} );

export const promotions = dataLayer.create( {
    sendPromoView( promo, callback ) {
        googleAnalyticsLayer.promoView( promo, callback );
        return this;
    },
    sendPromoClick( promo, callback ) {
        googleAnalyticsLayer.promoClick( promo, callback );
        return this;
    }
} );

const pageView = dataLayer.create( {
    homepage() {
        facebookPixelLayer.viewHomepage();
    },
    cart() {
        facebookPixelLayer.viewCart();
    },
    purchaseComplete( data ) {
        facebookPixelLayer.purchaseComplete( data );
    }
} );

dataLayer.cart = cart;
dataLayer.product = product;
dataLayer.promotions = promotions;
dataLayer.pageView = pageView;

export default dataLayer;
